angular.module('unergie.main')
.directive('userInfoAccountPot', ($uibModal, $filter, MS, AlertManager, BoFeaturesService, MetaWatcher,
    ModalService, PotService, ApiUser, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountPot.html',
        link($scope) {
            const feats = BoFeaturesService.getModuleFeatures('accountinfo')
            $scope.contractIds = []

            $scope.pot = {
                balance: null,
                excess: null,
                history: null,
            }

            const init = function (account) {
                if (account) {
                    return PotService.getPot(account.id, (error, pot) => {
                        if (error) {
                            AlertManager.error(error.data)
                        }
                        $scope.pot = pot
                    })
                }
            }

            $scope.isAIFeatureOn = (feature) => feats[feature]
            $scope.canGivePot = BoFeaturesService.isFeatureOn('givePot')

            $scope.openAddCreditToPot = () =>
                ModalService.openModal({ type: 'potModal', size: 'md', backdrop: 'static' }, { account: $scope.account, balance: $scope.pot.balance })



            const activate = function () {
                MetaWatcher.watch('POT_CHANGED', 'userInfoAccountPot', $scope, init)
                if ($scope.account) {
                    init($scope.account)
                }
            }

            $scope.openPotExplain = () => {
                if ($scope.isAIFeatureOn('viewPotExplanationV2')) {
                    ModalService.openModal({ type: 'potExplain', size: 'lg' }, { account: $scope.account }, (result) => {
                        if (result) {
                            init($scope.account)
                        }
                    })
                }
            }

            $scope.openPotUse = () => {
                ModalService.openModal({ type: 'states/userContractInfo/component/modals/potUseModal', size: 'lg' }, { account: $scope.account }, (result) => {
                    if (result) {
                        init($scope.account)
                    }
                })
            }

            $scope.loadPotExplaination = () => ApiUser.potExplaination({ id_account: $scope.account.id })

            activate()
        },
    }),
)
